import React, { FC } from "react";
import cn from "clsx";
import { Link } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars";
import { useTranslation } from "react-i18next";
import { CircleFlag } from "react-circle-flags";
import { DELIVERY_LOYALTY_TIERS } from "@/constants/loyalty-points";
import ModalBFL from "../../modal/modal";
import TierLabel from "../../tierLabel";
import { useIsRTL, useRouteSlug } from "@/hooks";
import { selectCommonSettings, selectStaticAssets } from "@/util/selectors";
import { useAppSelector } from "@/redux/store";
import HtmlParser from "../../html-parser";
import useDeliveryOptionsInfo from "@/routes/pdp/hooks/useDeliveryOptionsInfo";
import { ProductShippingOptionsProps } from "./types";

const ProductShippingOptions: FC<ProductShippingOptionsProps> = ({
  isModalShow,
  hideShippingOptionsModal
}) => {
  const { t } = useTranslation("productDetails");
  const isRTL = useIsRTL();
  const routeSlug = useRouteSlug();
  const commonSettings = useAppSelector(selectCommonSettings);
  const deliveryInfo = useDeliveryOptionsInfo();
  const staticAssets = useAppSelector(selectStaticAssets);

  return (
    <ModalBFL
      showModal={isModalShow}
      modalClass={cn(
        "generic_modal",
        "shipping_option_modal",
        "pdp_web_sizes",
        {
          arabic: isRTL
        }
      )}
    >
      <Scrollbars autoHeight autoHeightMin={200} autoHeightMax={530}>
        <button className="cross_btn" onClick={hideShippingOptionsModal}>
          &times;
        </button>
        <div className="shipping_modal_header">{t("shippingOptions")}</div>
        <div className="shipping_option">
          <div className="deliver_to">{t("deliverTo")}</div>
          <div className="info">
            <CircleFlag
              countryCode={commonSettings.countrySHORT.toLowerCase()}
              className="country_flag_img"
            />
            {commonSettings.countryName}
          </div>
        </div>
        <div className="modal_body">
          <ul className="table_data">
            {deliveryInfo.map((deliveryOption, index: number) => (
              <li className="shipping_modal_wrapper" key={index}>
                <span>{deliveryOption.deliveryType.label}</span>
                <span className="shipping_modal_info position-relative">
                  {deliveryOption?.deliveryMessages.map((message, index) => {
                    /* @ts-ignore */
                    return <HtmlParser html={message} key={index} />;
                  })}
                  {deliveryOption.tier === DELIVERY_LOYALTY_TIERS.Black && (
                    <TierLabel />
                  )}
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div className="modal_footer">
          <span className="info_icon" />
          <span className="info_text">{t("howToReturnYourOrder")} </span>
          <div className="lower_info_text">
            {t("seeOur")}{" "}
            <Link
              target="_blank"
              to={`/${routeSlug}${staticAssets?.returnAndCancelationSlug}`}
            >
              {t("returnsSmall")}
            </Link>{" "}
            {t("pageForMoreInfo")}
          </div>
        </div>
      </Scrollbars>
    </ModalBFL>
  );
};

export default ProductShippingOptions;
